'use client'
import React, { useState } from 'react'
import { Fragment } from 'react'
import LinkComponent from '@components/LinkComponent'
import Image from 'next/image'
import { Tab } from '@headlessui/react'
import CurrencySymbol from '@components/CurrencySymbol'
import { BiArea, BiSolidArea } from "react-icons/bi";
import { FaBed, FaBath } from "react-icons/fa"
import tailwindConfig from '@tailwind.config'

const ProjectProperties = ({ name, properties, saleProperties, rentProperties, lang, dictionary }) => {
    const [selectedIndex, setSelectedIndex] = useState(0)

  return (
    <div className='mb-2'>
        <h2 className='text-maincolor  font-semibold mb-1'>{dictionary.availableUnitsAt}{name}</h2>
        <Tab.Group selectedIndex={selectedIndex} onChange={setSelectedIndex}>
            <Tab.List className={`sm:w-1/2 w-full`}>
                <Tab as={Fragment} className={`w-1/2`}>
                    {({ selected }) => (
                        /* Use the `selected` state to conditionally style the selected tab. */
                        <button
                        className={
                            selected ? ` border-[1px] border-maincolor bg-maincolor text-light p-2 rounded-md` : ` border-[1px] border-maincolor p-2 rounded-md`
                        }
                        >
                            {dictionary.forSale} ({saleProperties})
                        </button>
                    )}
                </Tab>
                <Tab as={Fragment} className={`w-1/2`}>
                    {({ selected }) => (
                        /* Use the `selected` state to conditionally style the selected tab. */
                        <button
                        className={
                            selected ? ` border-[1px] border-maincolor bg-maincolor text-light p-2 rounded-md` : ` border-[1px] border-maincolor p-2 rounded-md`
                        }
                        >
                            {dictionary.forRent} ({rentProperties})
                        </button>
                    )}
                </Tab>
            </Tab.List>
            <Tab.Panels>
                <Tab.Panel>
                {properties.map((property, index) => 
                    ((property.saleType == 'sale' || property.saleType == 'salerent') && (
                        <>
                            <div className='sm:hidden block mt-2' key={property.id}>
                                <LinkComponent href={`/properties/${property.slug}`}>
                                    <div className='relative w-full aspect-[4/3] rounded-t-md overflow-hidden'>
                                        <Image
                                            // placeholder="blur"
                                            // blurDataURL={property.blur}
                                            // className='object-fit'
                                            className='object-cover'
                                            src={property.cover}
                                            // width={imageWidth}
                                            // height={imageHeight}
                                            fill={true}
                                            alt={property.slug}
                                        />
                                        {(property.videoUrl) ? (
                                            <div className='absolute w-full bottom-1 left-1 flex flex-row flex-wrap'>
                                                {/* {(property.foreignQuota && property.category == 'Condo' && property.saleType == 'sale') ? (
                                                    <div className={`rounded-md p-1 text-third border-third border-[1px] text-sm mr-1 flex flex-row items-center`}><MdPlaylistAddCheckCircle /><span className='ml-1'>Foreign Quota</span></div>
                                                ) : null} */}
                                                {property.videoUrl ? (
                                                    <div className={`rounded-md p-1 text-light bg-red-800 text-sm mr-1 flex flex-row items-center`}><IoMdVideocam /><span className='ml-1'>{dictionary.video}</span></div>
                                                ) : null}
                                                {/* {property.isSeaView ? (
                                                    <div className={`rounded-md p-1 bg-maincolor text-light border-light border-[1px] text-sm mr-1 flex flex-row items-center`}><FaWater /><span className='ml-1'>{dictionary.seaView}</span></div>
                                                ) : null} */}
                                                {/* {property.isBeachfront ? (
                                                    <div className={`rounded-md p-1 bg-third text-light border-third border-[1px] text-sm mr-1 flex flex-row items-center`}><MdBeachAccess /><span className='ml-1'>{dictionary.beachfront}</span></div>
                                                ) : null} */}
                                                {/* {property.isMountainView ? (
                                                    <div className={`rounded-md p-1 text-secondary border-secondary border-[1px] text-sm mr-1 flex flex-row items-center`}><FaMountain /><span className='ml-1'>Mountain View</span></div>
                                                ) : null} */}
                                            </div>
                                        ) : null}
                                        {/* {property.publicTransport ? (
                                            <div className='absolute flex flex-row flex-wrap bottom-0 left-0'>
                                                {property.publicTransport.map((transport, index) => (
                                                    <div key={index} style={{ backgroundColor: transport.colorCode }} className={`rounded-sm px-1 text-light text-sm ml-1 mb-1`}>{transport.type.toUpperCase()} {transport.stationName}</div>
                                                ))}
                                            </div>
                                        ) : null} */}
                                    </div>
                                    <div className='p-2'>
                                        {/* <div className='text-maincolor  font-semibold rounded-r-md z-10'><h3>{property.category} for {property.saleType !== 'salerent' ? property.saleType : 'Sale and Rent'}</h3></div> */}
                                        <div className='text-maincolor  font-semibold rounded-r-md z-10 h-[60px]'><h3 className='line-clamp-2'>{property.name}</h3></div>
                                        {property.oldSalePrice && (
                                            <div className='line-through text-gray-400 flex flex-row'><CurrencySymbol />{property.oldSalePrice}</div>
                                        )}
                                        <div className='flex sm:flex-row flex-col w-full '>
                                            {property.salePrice && (
                                                <div className=' font-semibold text-third w-1/2'><CurrencySymbol />{property.salePrice}</div>
                                            )}
                                        </div>
                                        {/* <div className='w-full border-b-[1px] border-forth pb-1 mb-1'>
                                            <p className='text-secondary '>{property.districts[0]?.subdistrictName?.[lang] ? property.districts[0]?.subdistrictName?.[lang] : property.districts[0]?.subdistrict}</p>
                                        </div> */}
                                        {(property.category == 'Condo' || property.category == 'House') &&
                                            <div className='flex flex-row w-full'>
                                                <div className='flex flex-row items-center w-1/2'>
                                                    <FaBed
                                                        color={tailwindConfig.theme.extend.colors.secondary}
                                                    />
                                                    <span className='ml-2  text-maincolor'>{property.bedrooms} {dictionary.beds}</span>
                                                </div>
                                                <div className='flex flex-row items-center w-1/2'>
                                                    <FaBath
                                                        color={tailwindConfig.theme.extend.colors.secondary}
                                                    />
                                                    <span className='ml-2  text-maincolor'>{property.bathrooms} {dictionary.baths}</span>
                                                </div>
                                            </div>

                                        }
                                        <div className='flex flex-row w-full justify-between'>
                                            {(property.category !== 'Land' || property.livingArea > 0) &&
                                                <div className='flex flex-row items-center w-1/2'>
                                                    <BiArea
                                                        color={tailwindConfig.theme.extend.colors.secondary}
                                                    />
                                                    <span className='ml-2  text-maincolor'>{property.livingArea} {dictionary.sqm}</span>
                                                </div>
                                            }
                                            {(property.category == 'Land' || property.landArea > 0) &&
                                                <div className='flex flex-row items-center w-1/2'>
                                                    <BiSolidArea
                                                        color={tailwindConfig.theme.extend.colors.secondary}
                                                    />
                                                    <span className='ml-2  text-maincolor'>{property.landArea} {dictionary.sqm}</span>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </LinkComponent>
                            </div>
                            <div className='sm:block hidden' key={property.id}>
                                <LinkComponent href={`/properties/${property.slug}`}>
                                    <div className='w-full flex flex-row items-center justify-between text-maincolor  py-2'>
                                        <div className='relative w-[120px] min-w-[120px] mr-2 aspect-[4/3] rounded-md overflow-hidden hover:border-[2px] hover:shadow-md  duration-150'>
                                            <Image
                                                // placeholder="blur"
                                                // blurDataURL={property.blur}
                                                // className='object-fit'
                                                className='object-cover cursor-pointer hover:shadow-xl'
                                                src={property.cover}
                                                // width={imageWidth}
                                                // height={imageHeight}
                                                fill={true}
                                                // alt={property.slug}
                                            />
                                        </div>
                                        <div className='sm:flex hidden w-1/3 flex-col'>
                                            <span className='text-third font-bold'><CurrencySymbol />{property.salePrice}</span>
                                            <p className='overflow-x-clip line-clamp-2'>{property.name}</p>
                                        </div>
                                        <div className='w-full'>
                                            <span className='sm:hidden block text-third font-bold'><CurrencySymbol />{property.salePrice}</span>
                                            <div className='flex flex-row justify-evenly items-center'>
                                                <div className='flex flex-col'>
                                                    <p className='font-semibold'>{property.isStudio ? `${dictionary.studio}` : `${property.bedrooms}` }</p>
                                                    <p>{dictionary.beds}</p>
                                                </div>
                                                <div className='flex flex-col'>
                                                    <p className='font-semibold'>{property.bathrooms ? `${property.bathrooms}` : `` }</p>
                                                    <p>{dictionary.baths}</p>
                                                </div>
                                                <div className='flex flex-col'>
                                                    <p className='font-semibold'>{property.livingArea ? `${property.livingArea}` : `` }</p>
                                                    <p>{dictionary.sqm}</p>
                                                </div>
                                                <button className='bg-maincolor text-light w-[80px] sm:w-[150px] h-8 rounded-md'>{dictionary.view}</button>
                                            </div>
                                        </div>
                                    </div>
                                </LinkComponent>
                            </div>
                        </>
                    ))
                )}
                </Tab.Panel>
                <Tab.Panel>
                {properties.map((property, index) => 
                    ((property.saleType == 'rent' || property.saleType == 'salerent') && (
                        <>
                            <div className='sm:hidden block mt-2' key={property.id}>
                                <LinkComponent href={`/properties/${property.slug}`}>
                                    <div className='relative w-full aspect-[4/3] rounded-t-md overflow-hidden'>
                                        <Image
                                            // placeholder="blur"
                                            // blurDataURL={property.blur}
                                            // className='object-fit'
                                            className='object-cover'
                                            src={property.cover}
                                            // width={imageWidth}
                                            // height={imageHeight}
                                            fill={true}
                                            alt={property.slug}
                                        />
                                        {(property.videoUrl) ? (
                                            <div className='absolute w-full bottom-1 left-1 flex flex-row flex-wrap'>
                                                {/* {(property.foreignQuota && property.category == 'Condo' && property.saleType == 'sale') ? (
                                                    <div className={`rounded-md p-1 text-third border-third border-[1px] text-sm mr-1 flex flex-row items-center`}><MdPlaylistAddCheckCircle /><span className='ml-1'>Foreign Quota</span></div>
                                                ) : null} */}
                                                {property.videoUrl ? (
                                                    <div className={`rounded-md p-1 text-light bg-red-800 text-sm mr-1 flex flex-row items-center`}><IoMdVideocam /><span className='ml-1'>{dictionary.video}</span></div>
                                                ) : null}
                                                {/* {property.isSeaView ? (
                                                    <div className={`rounded-md p-1 bg-maincolor text-light border-light border-[1px] text-sm mr-1 flex flex-row items-center`}><FaWater /><span className='ml-1'>{dictionary.seaView}</span></div>
                                                ) : null} */}
                                                {/* {property.isBeachfront ? (
                                                    <div className={`rounded-md p-1 bg-third text-light border-third border-[1px] text-sm mr-1 flex flex-row items-center`}><MdBeachAccess /><span className='ml-1'>{dictionary.beachfront}</span></div>
                                                ) : null} */}
                                                {/* {property.isMountainView ? (
                                                    <div className={`rounded-md p-1 text-secondary border-secondary border-[1px] text-sm mr-1 flex flex-row items-center`}><FaMountain /><span className='ml-1'>Mountain View</span></div>
                                                ) : null} */}
                                            </div>
                                        ) : null}
                                        {/* {property.publicTransport ? (
                                            <div className='absolute flex flex-row flex-wrap bottom-0 left-0'>
                                                {property.publicTransport.map((transport, index) => (
                                                    <div key={index} style={{ backgroundColor: transport.colorCode }} className={`rounded-sm px-1 text-light text-sm ml-1 mb-1`}>{transport.type.toUpperCase()} {transport.stationName}</div>
                                                ))}
                                            </div>
                                        ) : null} */}
                                    </div>
                                    <div className='p-2'>
                                        {/* <div className='text-maincolor  font-semibold rounded-r-md z-10'><h3>{property.category} for {property.saleType !== 'salerent' ? property.saleType : 'Sale and Rent'}</h3></div> */}
                                        <div className='text-maincolor  font-semibold rounded-r-md z-10 h-[60px]'><h3 className='line-clamp-2'>{property.name}</h3></div>
                                        {property.oldSalePrice && (
                                            <div className='line-through text-gray-400 flex flex-row'><CurrencySymbol />{property.oldSalePrice}</div>
                                        )}
                                        <div className='flex sm:flex-row flex-col w-full '>
                                            {property.salePrice && (
                                                <div className=' font-semibold text-third w-1/2'><CurrencySymbol />{property.salePrice}</div>
                                            )}
                                        </div>
                                        {/* <div className='w-full border-b-[1px] border-forth pb-1 mb-1'>
                                            <p className='text-secondary '>{property.districts[0]?.subdistrictName?.[lang] ? property.districts[0]?.subdistrictName?.[lang] : property.districts[0]?.subdistrict}</p>
                                        </div> */}
                                        {(property.category == 'Condo' || property.category == 'House') &&
                                            <div className='flex flex-row w-full'>
                                                <div className='flex flex-row items-center w-1/2'>
                                                    <FaBed
                                                        color={tailwindConfig.theme.extend.colors.secondary}
                                                    />
                                                    <span className='ml-2  text-maincolor'>{property.bedrooms} {dictionary.beds}</span>
                                                </div>
                                                <div className='flex flex-row items-center w-1/2'>
                                                    <FaBath
                                                        color={tailwindConfig.theme.extend.colors.secondary}
                                                    />
                                                    <span className='ml-2  text-maincolor'>{property.bathrooms} {dictionary.baths}</span>
                                                </div>
                                            </div>

                                        }
                                        <div className='flex flex-row w-full justify-between'>
                                            {(property.category !== 'Land' || property.livingArea > 0) &&
                                                <div className='flex flex-row items-center w-1/2'>
                                                    <BiArea
                                                        color={tailwindConfig.theme.extend.colors.secondary}
                                                    />
                                                    <span className='ml-2  text-maincolor'>{property.livingArea} {dictionary.sqm}</span>
                                                </div>
                                            }
                                            {(property.category == 'Land' || property.landArea > 0) &&
                                                <div className='flex flex-row items-center w-1/2'>
                                                    <BiSolidArea
                                                        color={tailwindConfig.theme.extend.colors.secondary}
                                                    />
                                                    <span className='ml-2  text-maincolor'>{property.landArea} {dictionary.sqm}</span>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </LinkComponent>
                            </div>
                            <div className='sm:block hidden' key={property.id}>
                                <LinkComponent href={`/properties/${property.slug}`}>
                                    <div className='w-full flex flex-row items-center justify-between text-maincolor  py-2'>
                                        <div className='relative w-[120px] min-w-[120px] mr-2 aspect-[4/3] rounded-md overflow-hidden hover:border-[2px] hover:shadow-md  duration-150'>
                                            <Image
                                                // placeholder="blur"
                                                // blurDataURL={property.blur}
                                                // className='object-fit'
                                                className='object-cover cursor-pointer hover:shadow-xl'
                                                src={property.cover}
                                                // width={imageWidth}
                                                // height={imageHeight}
                                                fill={true}
                                                // alt={property.slug}
                                            />
                                        </div>
                                        <div className='sm:flex hidden w-1/3 flex-col'>
                                            <span className='text-third font-bold'><CurrencySymbol />{property.salePrice}</span>
                                            <p className='overflow-x-clip line-clamp-2'>{property.name}</p>
                                        </div>
                                        <div className='w-full'>
                                            <span className='sm:hidden block text-third font-bold'><CurrencySymbol />{property.salePrice}</span>
                                            <div className='flex flex-row justify-evenly items-center'>
                                                <div className='flex flex-col'>
                                                    <p className='font-semibold'>{property.isStudio ? `${dictionary.studio}` : `${property.bedrooms}` }</p>
                                                    <p>{dictionary.beds}</p>
                                                </div>
                                                <div className='flex flex-col'>
                                                    <p className='font-semibold'>{property.bathrooms ? `${property.bathrooms}` : `` }</p>
                                                    <p>{dictionary.baths}</p>
                                                </div>
                                                <div className='flex flex-col'>
                                                    <p className='font-semibold'>{property.livingArea ? `${property.livingArea}` : `` }</p>
                                                    <p>{dictionary.sqm}</p>
                                                </div>
                                                <button className='bg-maincolor text-light w-[80px] sm:w-[150px] h-8 rounded-md'>{dictionary.view}</button>
                                            </div>
                                        </div>
                                    </div>
                                </LinkComponent>
                            </div>
                        </>
                    ))
                )}
                </Tab.Panel>
            </Tab.Panels>
        </Tab.Group>
        <div>

        </div>
    </div>
  )
}

export default ProjectProperties